<div class="p-3">
  <div class="mb-4">
    <h2 class="section-title">Calendario de Equipos</h2>
    <p class="text-muted">Agenda centralizada de mantenimientos, calibraciones y verificaciones técnicas.</p>
  </div>

  <div class="flex flex-wrap align-items-center justify-content-between mb-4 gap-3">
    <div class="flex-grow-1 text-center md:text-left">
      <p-buttonGroup>
        <p-button
          icon="pi pi-chevron-left"
          label="Anterior"
          mwlCalendarPreviousView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()"
          severity="secondary"
          size="small"
        />
        <p-button
          label="Hoy"
          mwlCalendarToday
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()"
          outlined="true"
          severity="secondary"
          size="small"
        />
        <p-button
          icon="pi pi-chevron-right"
          iconPos="right"
          label="Siguiente"
          mwlCalendarNextView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()"
          severity="secondary"
          size="small"
        />
      </p-buttonGroup>
    </div>

    <div class="flex-grow-1 text-center">
      <h3 class="m-0 font-semibold">{{ viewDate | calendarDate:(view + 'ViewTitle'):'es' }}</h3>
    </div>

    <div class="flex-grow-1 text-center md:text-right">
      <p-buttonGroup>
        <p-button
          label="Mes"
          (click)="setView(CalendarView.Month)"
          [outlined]="view !== CalendarView.Month"
          size="small"
        />
        <p-button
          label="Semana"
          (click)="setView(CalendarView.Week)"
          [outlined]="view !== CalendarView.Week"
          size="small"
        />
        <p-button
          label="Día"
          (click)="setView(CalendarView.Day)"
          [outlined]="view !== CalendarView.Day"
          size="small"
        />
      </p-buttonGroup>
    </div>
  </div>

  <div [ngSwitch]="view">
    <ng-template #customCellTemplate let-day="day" let-locale="locale">
      <div class="cal-cell-top">
        <span class="cal-day-badge" *ngIf="day.badgeTotal > 0">{{ day.badgeTotal }}</span>
        <span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
      </div>
      <div class="cal-events-custom" *ngIf="day.events.length > 0">
        <div
          *ngFor="let event of day.events"
          class="cal-event-block"
          [style.backgroundColor]="event.color?.primary || '#1D3364'"
          (click)="$event.stopPropagation(); eventClicked({event: event})"
          [title]="event.title"
        >
          {{ event.title }}
        </div>
      </div>
    </ng-template>

    <mwl-calendar-month-view
      *ngSwitchCase="CalendarView.Month"
      [viewDate]="viewDate"
      [events]="events"
      [activeDayIsOpen]="activeDayIsOpen"
      (dayClicked)="dayClicked($event.day)"
      (eventClicked)="eventClicked($event)"
      [cellTemplate]="customCellTemplate"
    >
    </mwl-calendar-month-view>
    <mwl-calendar-week-view
      *ngSwitchCase="CalendarView.Week"
      [viewDate]="viewDate"
      [events]="events"
      (eventClicked)="eventClicked($event)"
    >
    </mwl-calendar-week-view>
    <mwl-calendar-day-view
      *ngSwitchCase="CalendarView.Day"
      [viewDate]="viewDate"
      [events]="events"
      (eventClicked)="eventClicked($event)"
    >
    </mwl-calendar-day-view>
  </div>
</div>
